import { defineStore } from "pinia"
import { ref } from "vue"
import type { IConfig } from "@/common/interfaces"
import type { Variant } from "@/common/types/variant"
import type { IUser } from "@/common/types/user"
import _ from "lodash"

export const useConfig = defineStore("config", () => {
    const config = ref<IConfig>({})

    const getConfig = () => config.value

    const setConfig = (data: IConfig) => {
        config.value = data
    }

    const getVariant = () => config.value.variant
    const isVariant = (value: Variant): boolean => getVariant() === value
    const isInVariant = (values: Variant[]): boolean => _.includes(values, getVariant())
    const isNotVariant = (value: Variant): boolean => !isVariant(value)
    const isNotInVariant = (values: Variant[]): boolean => !isInVariant(values)

    const isAlwaysRestartInterview = (): boolean => config.value.isAlwaysRestartInterview
    const isShowVideoInReport = (): boolean => config.value.isShowVideoInReport
    const getWsServer = () => config.value.wsServer
    const isEvent = () => config.value.isEvent

    return {
        getConfig,
        setConfig,
        getVariant,
        isVariant,
        isInVariant,
        isNotVariant,
        isNotInVariant,
        isAlwaysRestartInterview,
        isShowVideoInReport,
        getWsServer,
        isEvent
    }
})

export const useUser = defineStore("user", () => {
    const user = ref<IUser>({})

    const getUser = (): IUser => user.value

    const setUser = (data: IUser) => {
        user.value = data
    }

    const setUserAvatar = (url: string) => {
        user.value.avatar = url
    }

    const setContactBalance = (value: number) => {
        user.value.contactBalance = value
    }

    return {
        getUser,
        setUser,
        setUserAvatar,
        setContactBalance
    }
})
